import { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { Route, Switch } from "react-router-dom";
import { ProductsMenuContext } from "../..";
import { OrganizationProductEditPage } from "../Index/pages/Edit";
import OrganizationProductNewPage from "../Index/pages/New";
import { OrganizationProductCompositionIndexPage } from "./pages/Index";

export const OrganizationProductCompositionPage = (props: RouteComponentProps) => {
	const { setMenuState } = useContext(ProductsMenuContext);

	useEffect(() => {
		setMenuState("composites");
	}, []);

	return (
		<Switch>
			<Route path={`${props.match.url}/`} exact component={OrganizationProductCompositionIndexPage} />
			<Route path={`${props.match.url}/new`} exact component={OrganizationProductNewPage} />
			<Route path={`${props.match.url}/:productId/edit`} component={OrganizationProductEditPage} />
		</Switch>
	);
};
